<a href="{{file}}" target="_blank" *ngIf="file" bkButton color="success" size="sm">
  <i class="fa fa-download"></i> Download
</a>
